import { render, staticRenderFns } from "./PublicationStatusLog.vue?vue&type=template&id=e4395c5c&"
import script from "./PublicationStatusLog.vue?vue&type=script&lang=ts&"
export * from "./PublicationStatusLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports